module.exports = __webpack_public_path__ + "static/media/down.ee9777c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/down.mp4
// module id = cWgN
// module chunks = 0